<template>
  <div class="container-fluid px-0" style="height: 600px" ref="vehicleTab">
    <div class="d-flex gap-5">
      <div
        class="base-button base-button--action py-15 gap-15"
        @click="$modal.show('addCommentModal')"
      >
        <img
          :src="require(`@/assets/icons/add.svg`)"
          width="13.5"
          height="13.5"
        />
        <span class="fsc-14">
          {{ dataLang["vehicle_modal_comments_text1"] }}</span
        >
      </div>
      <div
        class="base-button base-button--action py-15 gap-15"
        @click="acceptDelete"
      >
        <img
          :src="require(`@/assets/icons/adddel.svg`)"
          width="13.5"
          height="13.5"
        />
        <span class="fsc-14">{{
          dataLang["vehicle_modal_comments_text2"]
        }}</span>
      </div>
    </div>
    <div class="d-flex justify-content-between mt-15 mb-5">
      <div class="d-flex gap-15 align-items-center">
        <div
          class="btn btn-sm btn-thrity text-white fsc-14"
          @click="loadData(1)"
        >
          {{ dataLang["register_btn_filter_on"] }}
        </div>
        <div
          class="text-decoration-underline fsc-14 text-dark"
          style="cursor: pointer"
          @click="resetFilter"
        >
          {{ dataLang["register_btn_filter_off"] }}
        </div>
      </div>
      <BasePagination
        :page-count="computedAllPage"
        :pagination-params="activePagePagination"
        :page-range="10"
        :showLimitInput="false"
        :margin-pages="2"
        :break-view-class="''"
        :click-handler="loadData"
        :prev-text="''"
        :next-text="''"
        :container-class="'custom-pagination'"
        :page-class="'custom-pagination__item'"
        :pageLinkClass="'custom-pagination__item-link'"
        v-if="!localLoading"
      >
      </BasePagination>
    </div>
    <ve-table
      class="rest-style-table"
      style="width: 100%"
      :columns="columns"
      :table-data="dataTable"
      :border-x="true"
      :border-y="true"
      :sort-option="sortOption"
      ref="commentsTable"
      row-key-field-name="vehicle_comments__id"
      :cell-style-option="cellStyleOption"
      :checkbox-option="{
        hideSelectAll: true,
        selectedRowChange: selectedRowChange,
        selectedAllChange: selectedAllChange,
      }"
      v-if="!localLoading"
      :clickHighlight="false"
      :rowStyleOption="{
        hoverHighlight: true,
      }"
      :cellSelectionOption="{ enable: false }"
    />
    <AddNewCommentModalInCommentsTab
      :optionalParams="{ id: currentOpenedId }"
    ></AddNewCommentModalInCommentsTab>
    <Teleport to="body">
      <SimpleModal
        size="md"
        nameForAction="acceptDeletes"
        :modal-title="dataLang['vehicle_modal_service_modals_title_8']"
      >
        <template v-slot:content>
          <div
            class="tw-text-center tw-text-[23px] tw-mb-[15px] tw-text-forTitle"
          >
            {{ dataLang["vehicle_modal_service_modals_warning4"] }}
          </div>
          <div class="tw-h-[10px]"></div>
          <div class="tw-flex tw-gap-[10px] tw-mt-[15px] tw-justify-center">
            <button
              @click="closeDeleteModal"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["vehile_modal_btn_reset"] }}
            </button>
            <button
              @click="deleteRow"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              {{ dataLang["vehile_modal_btn_delete_ok"] }}
            </button>
          </div>
        </template>
      </SimpleModal>
    </Teleport>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
import { VeTable } from "vue-easytable";
import ObjectsService from "@/api/ObjectsService";
import AddNewCommentModalInCommentsTab from "@/components/vehicles-page-single-modal-inner/AddNewCommentModalInCommentsTab.vue";
import EventBus from "@/event-bus.js";
import SimpleModal from "@/components/vehicles-page-single-modal-inner/SimpleModal.vue";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
export default {
  components: {
    VeTable,
    SimpleModal,
    AddNewCommentModalInCommentsTab,
  },

  props: {
    modeOpenModal: {
      type: String,
      default: "create",
    },

    currentOpenedId: {
      type: Number,
    },
  },
  data() {
    return {
      localLoading: true,
      dataTable: [],
      activeSelectRowsMultiple: null,
      filter: [],
      computedAllPage: 1,
      activePagePagination: {},

      sortOption: {
        sortChange: (params) => {
          this.sortChange(params);
        },
      },
      rowStyleOption: {
        stripe: true,
      },
      cellSelectionOption: {
        enable: false,
      },
      cellStyleOption: {
        bodyCellClass: ({ row, column, rowIndex }) => {
          if (row.vehicle_comments__is_critical) {
            return "bg-danger";
          }
        },
      },
    };
  },
  methods: {
    sendData(callback, nameTab, oldTab, newTab, flagIsClose) {
      EventBus.$emit("contentLoaded");
      EventBus.$emit("updateContentData");
      callback(true, nameTab, oldTab, newTab, flagIsClose);
    },
    async loadExel() {
      let dataFrom = await ObjectsService.toExcel(this.currentOpenedId, {
        where: JSON.stringify(this.filter),
      });

      const filename = new Date().toISOString();
      const url = window.URL.createObjectURL(dataFrom.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${filename}.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
    },
    selectedRowChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
    selectedAllChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
    acceptDelete() {
      if (this.activeSelectRowsMultiple) {
        EventBus.$emit("openModal", {
          data: null,
          nameForAction: "acceptDeletes",
          mode: "create",
        });
      } else {
        this.$toast.error("Выберите хотя-бы одно поле", { duration: 5000 });
      }
    },
    closeDeleteModal() {
      EventBus.$emit("closeModal", {
        data: null,
        nameForAction: "acceptDeletes",
        mode: "create",
      });
    },

    deleteRow() {
      this.$emit("loadingModal", true);
      this.closeDeleteModal();
      ObjectsService.delete(
        "comments",
        this.currentOpenedId,
        this.activeSelectRowsMultiple
      )
        .then((data) => {
          this.loadData();
          this.activeSelectRowsMultiple = [];
          EventBus.$emit("updateContentData");
        })
        .catch((err) => {
          this.$emit("loadingModal", false);

          this.activeSelectRowsMultiple = [];
          this.$toast.error(err.response.data.message, { duration: 5000 });
        });
    },

    openModalSingle(nameModal) {
      EventBus.$emit("openModal", {
        data: null,
        nameForAction: nameModal,
        mode: "create",
      });
    },
    loadData(newNumPage) {
      this.$emit("loadingModal", true);
      this.urlToQuaries.params.page = newNumPage;
      ObjectsService.getAll(this.urlToQuaries).then((data) => {
        this.$emit("loadingModal", false);
        this.localLoading = false;
        this.activePagePagination = data.data.data;
        this.computedAllPage = data.data.data.total / data.data.data.limit;
        this.dataTable = data.data.data.rows;
        this.activeSelectRowsMultiple = null;
      });
    },
    resetFilter() {
      // this.selectsData
      this.filter = [];
      this.loadData();

      this.$refs.commentsTable.$el
        .querySelectorAll("input.base-input--new")
        .forEach((elem, index) => {
          elem.value = "";
        });
    },
    sortChange(params) {
      this.dataTable.sort((a, b) => {
        if (params.vehicle_services__created_at) {
          if (params.vehicle_services__created_at === "asc") {
            return (
              a.vehicle_services__created_at - b.vehicle_services__created_at
            );
          } else if (params.vehicle_services__created_at === "desc") {
            return (
              b.vehicle_services__created_at - a.vehicle_services__created_at
            );
          } else {
            return 0;
          }
        }
        if (params.vehicle_services__odometr) {
          if (params.vehicle_services__odometr === "asc") {
            return a.vehicle_services__odometr - b.vehicle_services__odometr;
          } else if (params.vehicle_services__odometr === "desc") {
            return b.vehicle_services__odometr - a.vehicle_services__odometr;
          } else {
            return 0;
          }
        }
        if (params.vehicle_services__text) {
          if (params.vehicle_services__text === "asc") {
            return a.vehicle_services__text - b.vehicle_services__text;
          } else if (params.vehicle_services__text === "desc") {
            return b.vehicle_services__text - a.vehicle_services__text;
          } else {
            return 0;
          }
        }
        if (params.vehicle_services__price) {
          if (params.vehicle_services__price === "asc") {
            return a.vehicle_services__price - b.vehicle_services__price;
          } else if (params.vehicle_services__price === "desc") {
            return b.vehicle_services__price - a.vehicle_services__price;
          } else {
            return 0;
          }
        }
        if (params.employees__name) {
          if (params.employees__name === "asc") {
            return a.employees__name - b.employees__name;
          } else if (params.employees__name === "desc") {
            return b.employees__name - a.employees__name;
          } else {
            return 0;
          }
        }
      });
    },
    fillFilter(data) {
      let newValueFilter =
        data.type == "like" ? `;percent;${data.value};percent;` : data.value;
      if (!this.filter.find((x) => x.field == data.name)) {
        this.filter.push({
          field: data.name,
          value: newValueFilter,
          ...(data.type == "like" && { operator: "like" }),
        });
      } else {
        this.filter[this.filter.findIndex((x) => x.field == data.name)].value =
          newValueFilter;
      }
    },
    ...mapActions("transportVehiclesModule", ["getHealth", "getTitle"]),
  },
  mounted() {
    EventBus.$on("contentLoaded", () => {
      this.loadData();
    });
    dayjs.extend(utc);
  },
  created() {
    this.$emit("loadingModal", true);
    this.getHealth(this.currentOpenedId);
    this.getTitle(this.currentOpenedId);
    this.loadData(1);
  },
  computed: {
    ...mapState("translationModule", ["dataLang"]),
    ...mapState("userSettingModule", ["userSetting"]),
    urlToQuaries() {
      return {
        url: `/${this.currentOpenedId}/comments`,
        params: {
          limit: 15,
          page: 1,
          ...(this.filter.length && { where: JSON.stringify(this.filter) }),
        },
      };
    },
    columns() {
      return [
        {
          field: "",
          key: "a",

          type: "checkbox",
          title: "",
          width: "3%",
          align: "center",
        },
        {
          field: "vehicle_comments__created_at",
          key: "1",
          title: this.dataLang["vehicle_modal_comments_table_header_text1"],
          align: "left",
          width: "10%",
          sortBy: "",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
                <BaseInputNew
                  placeholder=""
                  style={"width: 100%"}
                  disabled={false}
                  onInput={this.fillFilter}
                  additionalParams={{ type: "like" }}
                  inputName={"vehicle_comments__created_at"}
                  value={""}
                  nameSign={""}
                />
              </div>
            );
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {row.vehicle_comments__created_at
                  ? dayjs(row.vehicle_comments__created_at)
                      .utc(true)
                      .utcOffset(Number(this.userSetting.company__utc))
                      .format(
                        `${this.userSetting.company__tempalte_date} HH:mm`
                      )
                  : ""}
              </span>
            );
          },
        },
        {
          field: "vehicle_comments__text",
          key: "2",
          title: this.dataLang["vehicle_modal_comments_table_header_text3"],
          align: "left",
          width: 70,
          sortBy: "",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
                <BaseInputNew
                  placeholder=""
                  style={"width: 100%"}
                  disabled={false}
                  onInput={this.fillFilter}
                  additionalParams={{ type: "like" }}
                  inputName={"vehicle_comments__text"}
                  value={""}
                  nameSign={""}
                />
              </div>
            );
          },
        },
        {
          field: "employees__name",
          key: "3",
          title: this.dataLang["vehicle_modal_comments_table_header_text2"],
          align: "left",
          width: "10%",
          sortBy: "",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
                <BaseInputNew
                  placeholder=""
                  style={"width: 100%"}
                  disabled={false}
                  onInput={this.fillFilter}
                  additionalParams={{ type: "like" }}
                  inputName={"employees__name"}
                  value={""}
                  nameSign={""}
                />
              </div>
            );
          },
        },
      ];
    },
  },
};
</script>
